import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./header.css";
import logo from "../assets/images/logo.png";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => {
    setMenuOpen(false);
    setAboutOpen(false);
  };

  return (
    <header className="header">
      <div className="header-container">

        {/* LOGO */}
        <div className="logo-area">
          <img src={logo} alt="Belpimpalgaon Logo" />
          <div className="logo-text">
            <h1>बेलपिंपळगाव</h1>
            <span>परंपरा • संस्कृती • प्रगती</span>
          </div>
        </div>

        {/* MOBILE ICON */}
        <div
          className={`menu-icon ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* NAV */}
        <nav className={`nav ${menuOpen ? "open" : ""}`}>

          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
            onClick={closeMenu}
          >
            🏠 मुख्य पान
          </Link>


          <Link to="/bhushan" onClick={closeMenu}>🌟 बेलपिंपळगाव भूषण</Link>
          <Link to="/development" onClick={closeMenu}>🏗️ विकास कामे</Link>
          <Link to="/notice" onClick={closeMenu}>🔔 सूचना</Link>
          <Link to="/contact" onClick={closeMenu}>📞 संपर्क</Link>

          {/* BUTTONS */}
          <div className="nav-buttons">
            <Link to="/user-login" className="user-link" onClick={closeMenu}>
              👤 User Login
            </Link>
            <Link to="/admin" className="admin-link" onClick={closeMenu}>
              🔐 Admin
            </Link>
          </div>

        </nav>
      </div>
    </header>
  );
}
